export const OPEN_PUMP_DATA_SELECTION_MODAL = "OPEN_PUMP_DATA_SELECTION_MODAL";
export const CLOSE_PUMP_DATA_SELECTION_MODAL = "CLOSE_PUMP_DATA_SELECTION_MODAL";
export const OPEN_GRAPH_HI2_SELECTION_MODAL = "OPEN_GRAPH_HI2_SELECTION_MODAL";
export const CLOSE_GRAPH_HI2_SELECTION_MODAL = "CLOSE_GRAPH_HI2_SELECTION_MODAL";